import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getFaqsRescueProject(tenant: Tenant): Faq[] {
	return [
		{
			question: "Jak dlouho trvá převzetí projektu?",
			answer:
				"Přibližně týden máme vyhrazený na nasdílení potřebných přístupů od klienta. Následně 1–2 týdny tvoříme přehled projektu a definujeme krátkodobé i dlouhodobé cíle.",
		},
		{
			question: "Můžete pokračovat tam, kde předchozí dodavatel skončil?",
			answer:
				"Ve většině případů ano, často plynule navazujeme na práci předešlých dodavatelů. Pokud jsou však dosavadní řešení nesprávná, řekneme vám o tom a navrhneme menší či větší úpravy.",
		},
		{
			question: "Jak při převzetí projektů minimalizujete rizika?",
			answer: "Kvalitní a rychlou komunikací, pochopením problému a nastavením transparentního plánu.",
		},
		{
			question: "Dokážete opravit chyby, které současný vývojový tým nedokázal vyřešit?",
			answer: "Ano, s drtivou většinu chyb si naši odborníci díky letitým zkušenostem poradí.",
		},
		{
			question: "Jaké jsou náklady na převzetí projektu?",
			answer:
				"Převzetí a záchranu projektu naceňujeme podle domluvené hodinové sazby. Počet hodin strávených na projektu pak násobíme touto sazbou. O ceně každopádně budete mít přehled, nemusíte se obávat nepříjemných překvapení.",
		},
		{
			question: "Jak bude probíhat komunikace?",
			answer:
				"Vždy záleží na domluvě. Buď můžeme komunikaci kompletně převzít (včetně komunikace s původním dodavatelem), nebo se do ní můžete zapojit. Nebráníme se žádné variantě.",
		},
		{
			question: "Jak je to u převzetí projektu s vlastnickými právy kódu a dat?",
			answer:
				"Pokud původní kód a data máme převzít od předchozího dodavatele, je potřeba, abyste na ně měli vlastnická práva (např. licence).",
		},
	];
}
